<template>
  <div class="layout-padding">
    <div class="btn-group-justify-end">
      <button @click="clickReg" class="button is-primary" style="width:120px">공통 팀노트 등록</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="800"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="name" slot-scope="props" style="cursor:pointer;text-decoration:underline">
        <div @click="detailLink(props)">{{ props.item.name }}</div>
      </div>

      <div slot="modify_delete" slot-scope="props">
        <button class="button half"
                @click.stop.prevent="clickModifyDelete(props.item,'update')" style="margin-right:4px">수정</button>
        <button class="button half is-danger" @click.stop.prevent="clickModifyDelete(props.item,'delete')">삭제</button>
      </div>
    </admin-table>

  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  import GroupMixin from "@/mixins/GroupMixin"
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";

  export default {
    name: 'GroupBoardBaseList',
    layout:'Main',
    mixins: [
      ListMixin,
      GroupMixin
    ],
    components: {
      LpAdmDropInput
    },
    data () {
      return {
        cats: [],
        selectedGroup: '',
      }
    },
    created() {
      this.initializing('group_board_base', 'group/board/base');
      this.getData();
    },
    methods: {
      clickReg() {
        this.$router.push('base/create');
      },
      detailLink(props) {
        let board_id = props.item.id;
        this.$router.push(`base/post?board_id=${board_id}`);
      },
      clickModifyDelete(item, type) {
        if(type === 'update') {
          this.$router.push(this.getPath(`group/board/base/create?board_id=${item.id}`));
        }
        else if(type === 'delete') {
          let value = {
            url: `group/board/base/${item.id}`,
            title: '공통 팀노트를 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_main'


</style>
